import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StrictValuePipe } from '../../shared/pipes/strict-value.pipe';

@Component({
  selector: 'app-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrls: ['./switch-button.scss'],
})
export class SwitchButtonComponent implements OnInit {
  public selectList: Map<string, string> = new Map<string, string>();
  @Input() strictValueKey?: string;
  @Input() value?: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private _strictValuePipe: StrictValuePipe) {}

  ngOnInit(): void {
    this.selectList = this._strictValuePipe.strictValues(
      this.strictValueKey!,
      true
    )!;
  }

  isSelected(value: string): boolean {
    return this.value === value;
  }

  onClick(value: string): void {
    this.value = value;
    this.valueChange.emit(this.value);
  }

  originalOrder(
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number {
    return 0;
  }
}
